// Vetrina.js
import React from 'react';
import { Container, Card } from 'react-bootstrap';

const Vetrina = () => {
  return (
    <Container>
      <h1 className="text-center mt-4">Sito Vetrina Dei Menu</h1>
      <Card className="p-4">
        <h4>Pagina pubblcia con percorso /</h4>
        <p>Questa è la vetrina dell'applicazione soltanto con i vari sottodomini ci sara menu e admin pannel </p>
        {/* Aggiungi altre informazioni aziendali */}
      </Card>
    </Container>
  );
};

export default Vetrina;
